import styled from 'styled-components'
import { SIZES } from '../../styles/theme'

interface StarRatingStyleProps {
  activeColor?: string
  defaultColor?: string
}

export const StarRatingStyle = styled.div<StarRatingStyleProps>`
  button {
    border: none;
    background: transparent;
  }

  .titleContainer {
    display: flex;
    align-items: center;
    color: ${(p) => p.defaultColor};

    svg {
      margin-right: 12px;
      fill: ${(p) => p.defaultColor};
      height: 30px;
    }

    &:hover {
      .title {
        color: ${(p) => p.activeColor};
      }
      svg {
        fill: ${(p) => p.activeColor};
      }
    }
  }

  .starsContainer {
    > p {
      text-align: right;
      margin: 0;
      margin-top: 8px;
      margin-right: 10px;
      font-size: 14px;

      ${SIZES.mobile} {
        text-align: left;
        font-size: 10px;
        margin-left: 10px;
      }
    }
    svg {
      width: 30px;
      margin: 0 5px;

      &.filledStar {
        fill: ${(p) => p.activeColor};
      }
    }
  }
`
